import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { Link } from "gatsby";

// Components //
import Button from "../../atoms/button/button";
import TitleSection from "../../molecules/title-section";
import ParagraphCard from "../../molecules/paragraph-card/paragraphCard";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles //
import "./our-services-company.scss";
import ModalSolicitudServicios from "../../molecules/modal-solicitud-servicios/modalSolicitudServicios";

const OurServicesCompany = (props: ReferenciaContenido) => {
    const {
        tituloGeneral,
        tituloBoton,
        redireccionBoton,
        referenciaPlantillaContenido: refPlantilla,
    } = props;
    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);
    const refs = useRef<any>([]);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

    const CarouselServicesCompany = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
            refs.current.forEach((item, index) => {
                item.classList.remove("rotated");
                item.nextElementSibling?.classList.remove("open");
            });
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < refPlantilla.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;

    const isActiveNext = () => sliderIndex < refPlantilla.length - 1;

    const closeModal = () => {
		document.body.style.overflow = "scroll";
		setIsOpenModal((setShow) => !setShow);
	};

    return (
        <div className="o-our-services-company">
            <div className="container">
                <TitleSection title={tituloGeneral} />
                <div className="o-our-services-company__container">
                    <Slider
                        {...CarouselServicesCompany}
                        ref={(c) => {
                            setSlider(c);
                        }}
                    >
                        {refPlantilla.map((item, index) => (
                            <ParagraphCard
                                key={index}
                                title={item.tituloBanner}
                                imageSrc={item.imagenPrincipal[0].file.url}
                                index={index}
                                description={item.descripcion}
                                link={item.redireccionBoton}
                            />
                        ))}
                    </Slider>
                    <span
                        className={`arrow icon-chevron-left ${
                            isActiveBack() ? "active" : ""
                        }`}
                        onClick={goToBack}
                    ></span>
                    <span
                        className={`arrow  icon-chevron-right  ${
                            isActiveNext() ? "active" : ""
                        }`}
                        onClick={goToNext}
                    ></span>
                    <div className="o-our-services-company__container__button">
                        <Button
                            onClickAction={() => {
                                setIsOpenModal(true)
                            }}
                            type="button"
                            text={tituloBoton}
                            classname={"a-button__magenta gtmEmpresasClickButtonSolicitarServicios"}
                            isDisabled={false}
                        />
                    </div>
                </div>
                {isOpenModal && (
                    <ModalSolicitudServicios showModal={isOpenModal} onClose={closeModal}/>
                 )}
            </div>
        </div>
    );
};

export default OurServicesCompany;
